export default __webpack_public_path__ + "static/media/book.4d13a2a8.png";